var React = require('react');

function Slash (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"21st-Century-Pages","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"XQIAB-21stCentury-Desktop-Lander","transform":"translate(-276.000000, -2472.000000)","fill":"#02BEDF"},React.createElement("g",{"id":"collage","transform":"translate(234.000000, 1795.000000)"},React.createElement("polygon",{"id":"slash","points":"175.438486 677 142.264447 730.804571 108.624606 785.341744 65.7680381 854.840623 65.5532586 854.706927 42 893 109.164239 893 114.284046 884.704009 114.227666 884.661717 139.504531 843.675618 142.001342 839.615617 175.63313 785.079809 175.580777 785.002046 242 677"})))));
}

Slash.defaultProps = {"width":"200px","height":"216px","viewBox":"0 0 200 216","version":"1.1"};

module.exports = Slash;

Slash.default = Slash;
